import React from "react";

import Modal from "../Modal";
import ModalFooterCloseBtn from "../ModalFooterCloseBtn";

const MASTERY_COLORS = {
  0: "#ff8c42",
  1: "#f0ad4e",
  2: "#ffd54f",
  3: "#aec756",
  4: "#5cb85c"
};

const Checkmark = () => (
  <span className="glyphicon glyphicon-ok-circle mastery-help-modal-checkmark"></span>
);

export default class MasteryHelpModal extends React.Component {
  render() {
    const { collection, nextReviewByLevel, scope = "collection" } = this.props;
    const isCollection = scope === "collection";
    const title         = isCollection ? "Collection Mastery"           : "Mastery";
    const scopePhrase   = isCollection ? "in this collection"           : "across your deck";
    const scopeNoun     = isCollection ? "in this collection"           : "in your deck";
    const explainNoun   = isCollection ? "sentences in this collection" : "sentences in your deck";

    const c = collection;
    const levelCounts = c.levelCounts || {};
    const numSentences = c.numSentences || 0;
    const numPlaying = c.numPlaying || 0;

    const totalCheckmarks = numSentences * 4;
    // Bucket levels >= 4 together as "mastered" (level 4), cap checkmarks at 4 per sentence
    const bucketedCounts = {};
    Object.keys(levelCounts).forEach((k) => {
      const level = Math.min(Number(k), 4);
      bucketedCounts[level] = (bucketedCounts[level] || 0) + (levelCounts[k] || 0);
    });
    const checkmarksEarned = [0, 1, 2, 3, 4].reduce((sum, level) => sum + (bucketedCounts[level] || 0) * level, 0);
    const masteryPct = totalCheckmarks > 0 ? (checkmarksEarned / totalCheckmarks) * 100 : 0;

    const counts = [0, 1, 2, 3, 4].map((level) => bucketedCounts[level] || 0);
    const maxCount = Math.max(...counts, 1);
    const maxBarHeight = 100;

    return (
      <Modal
        title={title}
        footer={<ModalFooterCloseBtn />}
        ref={(el) => this.modal = el}
        onHidden={this.props.onHidden}
      >
        <div className="mastery-help-modal">
          <div className="mastery-help-modal-summary">
            <div className="mastery-help-modal-pct">
              <div className="mastery-help-modal-pct-label">You're at</div>
              <div className="mastery-help-modal-pct-value">
                {masteryPct.toFixed(2)}% Mastery
              </div>
              <div className="mastery-help-modal-pct-label">{scopePhrase}</div>
            </div>

            <hr style={{ margin: "0 20px 20px" }} />

            <div className="mastery-help-modal-stats">
              <p>
                There are <span className="joystix">{totalCheckmarks.toLocaleString()}</span>{" "}
                <Checkmark />{" "}
                to earn {scopeNoun}.
              </p>
              <p>
                (<span className="joystix">{numSentences.toLocaleString()}</span> sentences x{" "}
                {[0, 1, 2, 3].map((i) => (
                  <Checkmark key={i} />
                ))}{" "}
                each)
              </p>
              <p>
                You are playing <span className="joystix">{numPlaying.toLocaleString()}</span> sentences
                and currently have <span className="joystix">{checkmarksEarned.toLocaleString()}</span>/<span className="joystix">{totalCheckmarks.toLocaleString()}</span>{" "}
                <Checkmark />.
              </p>
            </div>
          </div>

          <div className="mastery-help-modal-section-title">Mastery breakdown</div>
          <div className="mastery-help-modal-breakdown">
            {[0, 1, 2, 3, 4].map((level) => {
              const count = bucketedCounts[level] || 0;
              const barHeight = maxCount > 0 ? Math.max((count / maxCount) * maxBarHeight, count > 0 ? 11 : 0) : 0;
              const color = MASTERY_COLORS[level];
              const percentage = level * 25;

              return (
                <div key={level} className="mastery-help-modal-breakdown-col">
                  <div
                    className="mastery-help-modal-breakdown-bar"
                    style={{ backgroundColor: color, height: barHeight }}
                  ></div>
                  <div className="mastery-help-modal-breakdown-count joystix">
                    {count.toLocaleString()}
                  </div>
                  <div className="mastery-help-modal-breakdown-pct">
                    <Checkmark />
                    {percentage}%
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mastery-help-modal-section-title">How does Mastery work?</div>
          <div className="mastery-help-modal-explainer">
            Mastery measures your progress learning {explainNoun}.
            Every time you answer a sentence correctly, you'll earn a checkmark{" "}
            <Checkmark />.
            When you answer a sentence correctly 4x in a row, it becomes 100% Mastered.
          </div>

          {/*
          {nextReviewByLevel && (
            <div>
              <p><strong>Get a sentence correct 4x in a row to get it to 100% Mastered.</strong></p>
              <p>Each correct answer sets the next review date further in the future.</p>
              <table className="table" style={{ marginTop: 12 }}>
                <thead>
                  <tr>
                    <th>A sentence that is</th>
                    <th>will be seen again in</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(nextReviewByLevel).sort((a, b) => Number(a) - Number(b)).map((k) => {
                    const level = Number(k);
                    const days = nextReviewByLevel[k];
                    return (
                      <tr key={k}>
                        <td>{level * 25}% Mastered</td>
                        <td>{days} {days === 1 ? "day" : "days"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          */}
        </div>
      </Modal>
    );
  }
}
